import { cx } from "../../lib/cx.js";
import { useFormFieldControl } from "../FormField/FormFieldContext.js";
/* empty css          */
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Input/Input.tsx
var INTERACTIVE = "a[href], button, input, select, textarea, [tabindex]";
/**
* A single-line text input in a bordered box, with optional leading and trailing slots.
* `className` goes on the box; every other prop, and the ref, go to the native `<input>`.
*/
var Input = forwardRef(function Input({ size = "md", leading, trailing, invalid: invalidProp, disabled, readOnly, className, id: idProp, "aria-describedby": describedByProp, ...rest }, ref) {
	const { id, "aria-describedby": describedBy, invalid } = useFormFieldControl({
		id: idProp,
		"aria-describedby": describedByProp,
		invalid: invalidProp
	});
	const handleMouseDown = (event) => {
		const target = event.target;
		if (disabled || target.closest(INTERACTIVE)) return;
		event.preventDefault();
		event.currentTarget.querySelector(".ds-input__field")?.focus();
	};
	return /* @__PURE__ */ jsxs("div", {
		className: cx("ds-input", `ds-input--${size}`, invalid && "ds-input--invalid", disabled && "ds-input--disabled", readOnly && "ds-input--readonly", className),
		onMouseDown: handleMouseDown,
		children: [
			leading != null && /* @__PURE__ */ jsx("span", {
				className: "ds-input__slot",
				children: leading
			}),
			/* @__PURE__ */ jsx("input", {
				ref,
				className: "ds-input__field",
				id,
				disabled,
				readOnly,
				"aria-invalid": invalid || void 0,
				"aria-describedby": describedBy,
				...rest
			}),
			trailing != null && /* @__PURE__ */ jsx("span", {
				className: "ds-input__slot",
				children: trailing
			})
		]
	});
});
//#endregion
export { Input };

//# sourceMappingURL=Input.js.map